import { XMarkIcon } from '@heroicons/react/16/solid';
import { ScoreBreakdown, ScoreBreakdownData } from './ScoreBreakdown';
import { GoInfo } from 'react-icons/go';
import { Link } from 'react-router-dom';

type ScoreBreakdownPanelProps = {
  rowData: any;
  onClose: () => void;
};

export function ScoreBreakdownPanel({ rowData, onClose }: ScoreBreakdownPanelProps) {
  const breakdown: ScoreBreakdownData | undefined = rowData?.scoreBreakdown?.[0];

  const geneLabel = rowData?.geneSymbol || rowData?.variantStrID || '';
  const diseaseLabel = rowData?.diseaseName || '';
  const associationLabel = [geneLabel, diseaseLabel].filter(Boolean).join(' — ');

  return (
    <div className="flex flex-col h-full bg-white overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between flex-shrink-0 px-4 py-3 border-b border-gray-200 bg-gray-50">
        <div className="flex items-center gap-1.5 min-w-0">
          <GoInfo className="w-5 h-4 stroke-1 text-blue m-1" />{' '}
          <h2 className="text-sm font-semibold text-gray-900 truncate min-w-0 mb-0 pb-0">Score Breakdown</h2>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="p-1.5 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-200 flex-shrink-0"
          aria-label="Close score breakdown"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>

      {/* Association label */}
      {associationLabel && (
        <div className="px-4 py-2 bg-blue-50 border-b border-blue-100">
          <p className="text-xs font-medium text-blue-800 truncate mb-0" title={associationLabel}>
            {associationLabel}
          </p>
        </div>
      )}

      {/* Content */}
      {breakdown ? (
        <>
          <div className="flex-1 overflow-y-auto p-3 min-h-0" id="score-breakdown-content">
            <ScoreBreakdown data={breakdown} />
          </div>
          {/* Fixed footer (no scroll) */}
          <div className="flex-shrink-0 px-4 py-2 border-t border-gray-200 bg-white">
            <small>
              See more information about the score breakdown <Link to="/docs?section=metrics">here</Link>
            </small>
          </div>
        </>
      ) : (
        <div className="flex-1 overflow-y-auto p-3 min-h-0" id="score-breakdown-content">
          <p className="text-sm text-gray-400 text-center mt-6">No score breakdown available.</p>
        </div>
      )}
    </div>
  );
}
